/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/Relations/Content/Relation/TreatmentInfo/Content"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let relationFromPersonRecordPatientAppointments0TxTxCardNameValueData = fromData.useDataValue({ viewPath,
context: 'relation',
path: 'from_person_record.patient.appointments.0.tx.tx_card.name',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let relationFromPersonRecordPatientAppointments0TxTxStatusName0NameValueData = fromData.useDataValue({ viewPath,
context: 'relation',
path: 'from_person_record.patient.appointments.0.tx.tx_status_name.0.name',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 display="inline"
 overflowX="hidden"
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 size="small"
 color={dtColorsNeutral900}
 data="relation.from_person_record.patient.appointments.0.tx.tx_card.name"
 text={relationFromPersonRecordPatientAppointments0TxTxCardNameValueData}
/>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 color={dtColorsNeutral900}
 data="relation.from_person_record.patient.appointments.0.tx.tx_status_name.0.name"
 text={relationFromPersonRecordPatientAppointments0TxTxStatusName0NameValueData}
/>
)}
</TysiaTag>
</div>
{children}
</React.Fragment>)
}